import {
	type JiraProjectStyle,
	type JiraProjectType,
	JIRA_PROJECT_STYLES,
	JIRA_PROJECT_TYPES,
} from '@jira/platform__project-types/src/project-types.tsx';
import type {
	JiraProjectStyle as JiraProjectStyleGQL,
	JiraProjectType as JiraProjectTypeGQL,
} from '@atlassian/jira-relay/src/__generated__/RecommendationCard_recommendation.graphql';

export const isJiraProjectStyle = (
	projectStyle: JiraProjectStyleGQL,
): projectStyle is JiraProjectStyle => projectStyle in JIRA_PROJECT_STYLES;

export const isJiraProjectType = (
	projectType: JiraProjectTypeGQL,
): projectType is JiraProjectType => projectType in JIRA_PROJECT_TYPES;
